export default __webpack_public_path__ + "static/media/SupportShell.0b4c135e.svg";